import { Button, Card, Form, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { ReactElement, useState } from 'react';
import { APNDataType } from './interface';
import { useParams } from 'react-router-dom';
import { setAWSCreds } from '../../../../utils/accessToken';
import { putAPNData } from './api';
interface APNProps {
  APNData?: APNDataType;
}
const APNform = (props: APNProps): ReactElement => {
  const { accountId } =
    useParams<{
      accountId: string;
    }>();
  const [componentDisabled, setComponentDisabled] = useState<boolean>(
    props.APNData ? true : false
  );
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: { span: 14 },
    wrapperCol: { span: 14 }
  };
  const buttonItemLayout = { wrapperCol: { span: 14, offset: 14 } };
  const APNImage = window.origin + '/img/Apple_logo_black.png';

  const onFinish = (values: {
    accountId: string;
    Topic: string;
    Key: string;
    KeyId: string;
    TeamId: string;
  }) => {
    setAWSCreds().then(() => {
      putAPNData(
        accountId,
        values.Topic,
        values.Key,
        values.KeyId,
        values.TeamId
      ).then(() => {
        setComponentDisabled(true);
      });
    });
  };
  return (
    <Card>
      <Row
        style={{
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}
      >
        <img
          src={APNImage}
          alt="Apple icon"
          style={{ width: '100px', height: 'auto' }}
        />
      </Row>
      <Row style={{ justifyContent: 'center' }}>
        <b>APN</b>
      </Row>
      <Row>
        <Form
          {...formItemLayout}
          form={form}
          disabled={componentDisabled}
          style={{ minWidth: 700 }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Key Id:"
            name="KeyId"
            initialValue={props.APNData?.KeyId}
            rules={[{ required: true, message: 'Please input the Key Id!' }]}
          >
            <Input placeholder="KeyId" />
          </Form.Item>
          <Form.Item
            label="Key:"
            name="Key"
            initialValue={props.APNData?.Key}
            rules={[{ required: true, message: 'Please input the Key!' }]}
          >
            <TextArea
              disabled={componentDisabled}
              rows={4}
              placeholder="-----BEGIN PRIVATE KEY-----"
            />
          </Form.Item>
          <Form.Item
            label="Team Id:"
            name="TeamId"
            initialValue={props.APNData?.TeamId}
            rules={[{ required: true, message: 'Please input the Team Id!' }]}
          >
            <Input placeholder="TeamId" />
          </Form.Item>
          <Form.Item
            label="Topic (App Bundle Id):"
            name="Topic"
            initialValue={props.APNData?.Topic}
            rules={[
              { required: true, message: 'Please input the App Bundle Id!' }
            ]}
          >
            <Input placeholder="App Bundle Id" />
          </Form.Item>
          <Form.Item style={{ padding: '10px' }} {...buttonItemLayout}>
            <>
              {componentDisabled ? (
                <>
                  <Button
                    key={'Edit'}
                    disabled={!componentDisabled}
                    type="dashed"
                    htmlType="submit"
                    style={{ marginRight: '10px' }}
                    onClick={() => setComponentDisabled(false)}
                  >
                    Edit
                  </Button>
                </>
              ) : (
                <Button
                  key={'Submit'}
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: '10px' }}
                >
                  {props.APNData ? 'Submit' : 'Save'}
                </Button>
              )}
            </>
          </Form.Item>
        </Form>
      </Row>
    </Card>
  );
};
export default APNform;
